import { render, staticRenderFns } from "./publicDemand.vue?vue&type=template&id=0235cf3c&scoped=true"
import script from "./publicDemand.vue?vue&type=script&lang=js"
export * from "./publicDemand.vue?vue&type=script&lang=js"
import style0 from "./publicDemand.vue?vue&type=style&index=0&id=0235cf3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0235cf3c",
  null
  
)

export default component.exports